<!--
 * @Author: Nemo
 * @Description: OnDialog组件 - 移动端实现
 * @Date: 2025-11-19
-->
<template>
  <div v-if="visible || closing" class="on-dialog">
    <!-- 弹窗蒙层 -->
    <div class="on-dialog-mask" @click="handleMaskClick" :class="{ 'mask-fade-out': closing }" />

    <!-- 移动端底部弹窗 -->
    <div class="on-dialog-container mobile-popup" :class="{ 'slide-down': closing }">
      <div class="popup-header" v-if="title">
        <div class="popup-title">{{ title }}</div>
        <div class="popup-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="popup-content">
        <slot></slot>
      </div>
      <div class="popup-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
      <div class="popup-footer" v-else-if="showDefaultFooter">
        <on-button class="popup-confirm-btn" @click="handleConfirm">
          {{ confirmText }}
        </on-button>
        <div class="popup-cancel-text" @click="handleCancel">
          {{ cancelText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OnButton from '../button/index.vue';

export default {
  name: 'OnDialogMobile',
  components: {
    OnButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    closeOnClickMask: {
      type: Boolean,
      default: true,
    },
    showDefaultFooter: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: '确认',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  data() {
    return {
      closing: false,
    };
  },
  mounted() {
    if (this.visible) {
      document.body.style.overflow = 'hidden';
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        if (!this.closing) {
          document.body.style.overflow = '';
        }
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    /**
     * 关闭弹窗
     * @author Nemo
     */
    handleClose() {
      this.closing = true;
      setTimeout(() => {
        this.closing = false;
        this.$emit('update:visible', false);
        this.$emit('close');
        document.body.style.overflow = '';
      }, 300);
    },

    /**
     * 点击蒙层
     * @author Nemo
     */
    handleMaskClick() {
      if (this.closeOnClickMask) {
        this.handleClose();
      }
    },

    /**
     * 确认按钮
     * @author Nemo
     */
    handleConfirm() {
      this.$emit('confirm');
    },

    /**
     * 取消按钮
     * @author Nemo
     */
    handleCancel() {
      this.$emit('cancel');
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 蒙层样式 */
.on-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  backdrop-filter: blur(4px);
  transition: opacity 0.3s ease;

  &.mask-fade-out {
    opacity: 0;
  }
}

/* 容器样式 */
.on-dialog-container {
  position: fixed;
  z-index: 2001;
  background: #FFFFFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

/* 移动端样式 */
.mobile-popup {
  left: 0;
  bottom: 0;
  width: 100%;
  border-radius: 20px 20px 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  padding: 24px;
  animation: slide-up 0.3s ease;

  &.slide-down {
    transform: translateY(100%);
  }
}

.mobile-popup .popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

.mobile-popup .popup-title {
  font-weight: 600;
  font-size: 20px;
  color: #1A202C;
}

.mobile-popup .popup-close {
  cursor: pointer;
  color: #8D98AF;
  font-size: 20px;
  line-height: 1;
}

.mobile-popup .popup-content {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
  font-size: 14px;
  color: #667085;
  line-height: 18px;
}

.mobile-popup .popup-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 16px;
}

.mobile-popup .popup-confirm-btn {
  width: 100%;
}

.mobile-popup .popup-cancel-text {
  font-size: 16px;
  color: var(--brand-color, #182058);
  cursor: pointer;
  text-align: center;
  padding: 8px;
  transition: opacity 0.3s;
}

.mobile-popup .popup-cancel-text:active {
  opacity: 0.6;
}

/* 动画 */
@keyframes slide-up {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
